export class AuthError extends Error {
  constructor(message: string) {
    super('[AuthError] ' + message);
  }
}
// API-specific errors (for backend communication)
export class APIAuthError extends AuthError {}
export class TokenInvalidError extends APIAuthError {}
export class TokenExpiredError extends APIAuthError {}
export class TokenNotFoundError extends APIAuthError {}
export class AuthUserNotFoundError extends APIAuthError {}
export class AuthInvalidPasswordError extends APIAuthError {}

// OIDC-specific errors
export class OIDCError extends AuthError {}
export class OICDTokenExchangeError extends OIDCError {}
export class OIDCInvalidPasswordError extends OIDCError {}
export class OIDCUserNotFoundError extends OIDCError {}

// Server Error
export class AuthServerError extends AuthError {}
